// Geometry types
export const GEOMETRY_TYPES = {
  POINT: 'point',
  POLYGON: 'polygon',
  POLYLINE: 'polyline',
} as const;

// Sketch event states
export const SKETCH_STATES = {
  COMPLETE: 'complete',
  ACTIVE: 'active',
  CANCEL: 'cancel',
} as const;

// Sketch event types
export const SKETCH_EVENT_TYPES = {
  CREATE: 'create',
  DELETE: 'delete',
  UPDATE: 'update',
} as const;

// Tool event info types
export const TOOL_EVENT_TYPES = {
  VERTEX_ADD: 'vertex-add',
} as const;

// Measurement units
export const UNITS = {
  METERS: 'meters',
  SQUARE_METERS: 'square-meters',
} as const;

// Conversion factors
export const CONVERSIONS = {
  // Distance conversions
  METERS_TO_FEET: 3.28084,
  FEET_PER_MILE: 5280,
  DEGREES_TO_METERS_APPROX: 111320,

  // Area conversions
  SQUARE_METERS_TO_SQUARE_FEET: 10.764,
  SQUARE_METERS_PER_SQUARE_KILOMETER: 1000000,
  SQUARE_FEET_PER_SQUARE_MILE: 27878400,

  // Thresholds
  METERS_PER_KILOMETER: 1000,
} as const;
